
import { mapGetters } from 'vuex';
import Back from '../elements/Back.vue';

export default {
  name: 'HeaderComponent',
  components: { Back },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      isOverlayActive: 'ui/isOverlayActive'
    })
  },

  methods: {
    toggleNavOverlay() {
      this.$store.commit('ui/toggleOverlay', !this.isOverlayActive);
    }
  }
};
